import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LoadingOverlay } from "./SharedComponents";
import { tokenLogin } from "../services/API";

const TokenExtractor = ({ onTokenExtracted }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = new URLSearchParams(location.search).get("token");

    if (!token) {
      navigate("/login");
      return;
    }

    onTokenExtracted(token);
  }, [location, navigate, onTokenExtracted]);

  return null;
};

const TokenLoginProcessor = ({ token }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) return;

    handleTokenLogin(token, navigate);
  }, [token, navigate]);

  return null;
};

const handleTokenLogin = async (token, navigate) => {
  const response = await tokenLogin(token);
  if (response.success) {
    navigate("/chat");
  } else {
    navigate("/login");
  }
};

const TokenLogin = () => {
  const [token, setToken] = React.useState(null);
  return (
    <>
      <TokenExtractor onTokenExtracted={setToken} />
      <TokenLoginProcessor token={token} />
      <LoadingOverlay />
    </>
  );
};

export default TokenLogin;
